import { styled } from '@mui/material';
import { DropdownList as _DropdownList } from '~/components/commons/DropdownList_v1';

export const DropdownList = styled(_DropdownList)`
  height: 34px;
  .MuiAutocomplete-inputRoot.MuiInputBase-root.MuiOutlinedInput-root {
    height: 34px;
  }
`;
